import React from 'react'

import * as S from './button-icon.styled'

interface VisitorParkingButtonIconProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode
}

export const ButtonIcon = ({ children, className, ...props }: VisitorParkingButtonIconProps) => {
  return (
    <S.StyledButtonIcon className={className} {...props}>
      {children}
    </S.StyledButtonIcon>
  )
}
